var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15C16 15.5523 15.5523 16 15 16H1C0.447719 16 0 15.5523 0 15C0 14.4477 0.447719 14 1 14H15C15.5523 14 16 14.4477 16 15ZM7.29291 11.8321C7.48819 12.0274 7.74406 12.125 8 12.125C8.25587 12.125 8.51188 12.0274 8.70709 11.8321L12.2502 8.28909C12.6407 7.89856 12.6407 7.26541 12.2502 6.87488C11.8596 6.48434 11.2265 6.48434 10.8359 6.87488L9 8.71081V1C9 0.447719 8.55228 0 8 0C7.44772 0 7 0.447719 7 1V8.71081L5.16406 6.87488C4.77353 6.48434 4.14038 6.48434 3.74984 6.87488C3.35931 7.26541 3.35931 7.89856 3.74984 8.28909L7.29291 11.8321Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.95742b7d0ac77c99cbc3847c9e73fa13.svg";